import React, { useCallback, useMemo } from "react";
import { Button, IconButton } from "@mui/material";
import classNames from "classnames";
import { useSelector } from "react-redux";
import {
  Add,
  Info ,
  OpenInNew as OpenInNewIcon,
  Edit
} from "@mui/icons-material";
import {Tooltip, Typography } from "@mui/material";
import styles from "./Styles.module.css";
import DataTables from "../../../Datatables/Datatable.table";
import Constants from "../../../config/constants";
import FilterComponent from "../../../components/Filter/Filter.component";
import useAdminUsersListHook from "./AdminUsersList.hook";
import capitalizeFirstLetter from "../../../hooks/CommonFunction";
import { ArrowPrimaryButton } from "../../../components/Buttons/PrimaryButton";
import StatusPill from "../../../components/Status/StatusPill.component";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import useRoles from "../../../hooks/RoleHook";

const AdminUsersList = (props) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    handleDetail,
    handleFilterDataChange,
    handleSearchValueChange,
    handleProfile,
    configFilter,
    handleCreate,
    handleEdit,
    getInitials
  } = useAdminUsersListHook({});
  const {canRead, canCreate, canUpdate} = useRoles(Constants.MODULES.ADMIN_USERS);
  const {
    present,
    all: allData,
    currentPage,
    is_fetching: isFetching,
  } = useSelector((state) => state.admin);

  const renderFirstCell = useCallback((user) => {
    return (
      <div className={styles.firstCellFlex}>
        <div  className={styles.contactImg}><Typography color={"primary"} variant="h5"> {getInitials(user.name)}</Typography></div> 
        <div className={classNames(styles.firstCellInfo, "openSans")}>
          <div>{`${capitalizeFirstLetter(user?.name)}`} </div>
          
        </div>
      </div>
    );
  }, []);

const renderStatus = useCallback((status) => {
    if (status === "ACTIVE") {
      return <StatusPill status={"Active"} color={"active"} />;
    } else if (status === "INACTIVE") {
      return <StatusPill status={"Inactive"} color={"high"} />;
    }
  }, []);

  const tableStructure = useMemo(
    () => [
      {
        key: "name",
        label: "User Info",
        sortable: false,
        render: (value, all) => <div>{renderFirstCell(all)}</div>,
      },
      {
        key: "type",
        label: "Type",
        sortable: false,
        render: (temp, all) => <div>{all?.type === "ADMIN" ? "Admin" : all?.type === "CLIENT_USER" ? "Client" : "N/A"}</div>
      },
      {
        key: "role",
        label: "Role",
        sortable: false,
        render: (temp, all) => <div>{all?.role?.name ?? "N/A"}</div>
      },
      {
        key: "email",
        label: "Email ID",
        sortable: false,
        render: (temp, all) => <div>{all?.email}</div>
      },
      {
        key: "last_login",
        label: "Last Login",
        sortable: false,
        render: (temp, all) => <div>{all?.lastLoginText}</div>
      },
      {
        key: "status",
        label: "Status",
        sortable: false,
        render: (temp, all) => <div>{renderStatus(all.status)}</div>,
      },
     
        {
          key: "user_id",
          label: "Action",
          render: (temp, all) => (
            <div className={styles.actionButton}>
             {canRead && 
              <Tooltip
              title={<>View Detail</>}
              aria-label="info"
              placement="right"
              className={styles.infoTip}
            > 
             <IconButton
        disableRipple="false"
        onClick={() => {
          
          handleDetail(all);
        }}
      >
        <Info
          fontSize={"small"}
         
        />
      </IconButton>
      </Tooltip>
      }

              {/* {canUpdate &&<IconButton
                
                onClick={() => handleEdit(all)}
              >
                <Edit fontSize={"small"} />
              </IconButton>}
               */}
            </div>
          ),
        },
    ],
    [renderFirstCell, renderStatus, handleDetail, handleProfile]
  );
  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };
    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: present,
      count: allData.length,
      page: currentPage,
    };

    return { datatableFunctions, datatable };
  }, [
    allData,
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    present,
    currentPage,
  ]);

  return (
    <ShadowBox className={styles.contact}>
      {/* <div className={"plainPaper"}> */}
      <div className={styles.headerContainer}>
        <Typography
          variant={"h5"}
          color={"text.primary"}
          className={styles.title}
        >
          Admin Users
        </Typography>
        {/* { canCreate && <ArrowPrimaryButton
          onClick={handleCreate}
          icon={<Add fontSize="normal" />}
        >
          CREATE
        </ArrowPrimaryButton>} */}
      </div>
     

      <div>
        <FilterComponent
          is_progress={isFetching}
          filters={configFilter}
          handleSearchValueChange={handleSearchValueChange}
          handleFilterDataChange={handleFilterDataChange}
          placeholder="Search by user name"
        />
        <div>
          <br />
          <div style={{ width: "100%" }}>
            <DataTables
              {...tableData.datatable}
              {...tableData.datatableFunctions}
            />
          </div>
        </div>
      </div>
      {/* </div> */}
    </ShadowBox>
  );
};

export default AdminUsersList;
